import { Currency } from '../types/api/Currency/Currency';
import * as CurrencyHelpers from './currency';

/** Returns price * quantity (quantity defaults to 1 when null) as a Currency. */
export const CalculateExtendedPriceCurrency = (
  priceUnit: number,
  quantity: string | null,
): Currency => {
  const parsedQuantity = quantity === null ? null : parseFloat(quantity);
  return new Currency({
    number: (priceUnit * (parsedQuantity ?? 1)).toFixed(2),
    currency: 'USD',
  });
};

/** Returns quantity * productQuantity, or null if either is null. */
export const CalculateEstimatedYards = (
  quantity: string | null,
  productQuantity: number | null,
): number | null =>
  quantity === null || productQuantity === null ? null : parseFloat(quantity) * productQuantity;

/** display-friendly thousands-separated CalculateEstimatedYards result */
export const FormatEstimatedYards = (estimatedYards: number | null): string | null =>
  estimatedYards === null
    ? null
    : CurrencyHelpers.numericFormatter(String(estimatedYards), { thousandSeparator: true });

/** Returns extendedPriceNumber / estimatedYards, or null if estimatedYards is 0 or null. */
export const CalculatePricePerYard = (
  extendedPriceNumber: string,
  estimatedYards: number | null,
): number | null =>
  estimatedYards === null || estimatedYards === 0
    ? null
    : parseFloat(extendedPriceNumber) / estimatedYards;
